import React, { useState, useEffect } from "react";
import { useApp } from "../context/AppContext";
import { Helmet } from "react-helmet-async";


const NEARBY = [
  { name: "Ravi Kumar", dist: "2.3 km", bike: "KTM Duke 390", status: "online", avatar: "RK" },
  { name: "Priya Desai", dist: "4.1 km", bike: "RE Himalayan", status: "online", avatar: "PD" },
  { name: "Arjun Mehta", dist: "6.8 km", bike: "Yamaha R15", status: "away", avatar: "AM" },
];

export default function SOS() {
  const { user } = useApp() || {};

  const [sosState, setSosState] = useState("idle");
  const [countdown, setCountdown] = useState(5);
  const [issue, setIssue] = useState("");
  const [location, setLocation] = useState("Detecting...");
  const [coords, setCoords] = useState(null);
  const [startTime, setStartTime] = useState(null);

  // 📍 Get location
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          const lat = pos.coords.latitude;
          const lng = pos.coords.longitude;
          setCoords({ lat, lng });
          setLocation(`Lat: ${lat.toFixed(4)}, Lng: ${lng.toFixed(4)}`);
        },
        () => setLocation("Location unavailable")
      );
    }
  }, []);

  // ⏳ Countdown logic
  useEffect(() => {
    if (sosState === "countdown") {
      if (countdown === 0) {
        setStartTime(Date.now());
        setSosState("active");
        return;
      }
      const t = setTimeout(() => setCountdown((c) => c - 1), 1000);
      return () => clearTimeout(t);
    }
  }, [sosState, countdown]);

  const playAlert = () => {
    const audio = new Audio("/alert.mp3");
    audio.play();
  };

  const startSOS = () => {
    playAlert();
    setCountdown(5);
    setSosState("countdown");
  };

  const cancelSOS = () => {
    setSosState("idle");
    setCountdown(5);
  };

  const resolve = () => setSosState("resolved");

  const emergencyContact = "9876543210";

  return (
    
    <div style={{ padding: 30, maxWidth: 700 }}>
<Helmet>
  <title>Emergency SOS for Bike Riders | Nearby Help & Rider Support | MotoHub India</title>

  <meta
    name="description"
    content="Use MotoHub India SOS to alert nearby riders during bike breakdown, accident, or emergency. Share live location and get instant help from riders near your city."
  />

  <meta
    name="keywords"
    content="bike SOS India, rider emergency help, motorcycle breakdown help India, nearby riders support, bike accident help, rider safety India, SOS bike app"
  />

  <meta property="og:title" content="Emergency SOS for Bike Riders | MotoHub India" />
  <meta property="og:description" content="Send SOS alerts, share live location, and get help from nearby riders instantly." />
  <meta property="og:image" content="https://motohubindia.com/logo.png" />
  <meta property="og:url" content="https://motohubindia.com/sos" />

  <meta name="robots" content="index, follow" />
</Helmet>
      <h1 style={{ color: sosState === "active" ? "red" : "#fff" }}>
        🚨 EMERGENCY SOS
      </h1>

      {/* IDLE */}
      {sosState === "idle" && (
        <div style={{ textAlign: "center", marginTop: 30 }}>
          <p>{location}</p>

          <select value={issue} onChange={(e) => setIssue(e.target.value)}>
            <option value="">Select Issue</option>
            <option>Breakdown</option>
            <option>Flat Tyre</option>
            <option>Fuel Empty</option>
            <option>Accident</option>
          </select>

          <br /><br />

          <button onClick={startSOS} style={sosBtn}>
            SOS
          </button>
        </div>
      )}

      {/* COUNTDOWN */}
      {sosState === "countdown" && (
        <div style={{ textAlign: "center" }}>
          <h1 style={{ fontSize: 80, color: "red" }}>{countdown}</h1>
          <button onClick={cancelSOS}>Cancel</button>
        </div>
      )}

      {/* ACTIVE */}
      {sosState === "active" && (
        <div>

          <div style={alertBox}>
            🚨 SOS ACTIVE — Riders notified
          </div>

          {/* INFO */}
          <div style={grid}>
            <div>📍 {location}</div>
            <div>⚠ {issue || "Not specified"}</div>
            <div>👥 3 riders notified</div>
            <div>
              ⏱ Active: {startTime ? Math.floor((Date.now() - startTime) / 1000) : 0}s
            </div>
          </div>

          {/* MAP */}
          {coords && (
            <a
              href={`https://www.google.com/maps?q=${coords.lat},${coords.lng}`}
              target="_blank"
            >
              📍 Open in Google Maps
            </a>
          )}

          {/* WHATSAPP */}
          {coords && (
            <div>
              <a
                href={`https://wa.me/?text=🚨 SOS Help Needed! Location: https://maps.google.com/?q=${coords.lat},${coords.lng}`}
                target="_blank"
              >
                Share on WhatsApp
              </a>
            </div>
          )}

          {/* RIDERS */}
          <h3>Nearby Riders</h3>
          {NEARBY.map((r) => (
            <div key={r.name} style={riderCard}>
              <div>{r.name} ({r.dist})</div>
              <button style={comingBtn}>I'm Coming</button>
            </div>
          ))}

          {/* ACTIONS */}
          <div style={{ marginTop: 20 }}>
            <button onClick={resolve} style={resolveBtn}>
              Resolved
            </button>

            <a href={`tel:${emergencyContact}`}>
              <button style={callBtn}>Call</button>
            </a>
          </div>
        </div>
      )}

      {/* RESOLVED */}
      {sosState === "resolved" && (
        <div style={{ textAlign: "center" }}>
          <h2>✅ You are safe!</h2>
          <button onClick={() => setSosState("idle")}>
            Back
          </button>
        </div>
      )}
    </div>
  );
}

// 🎨 STYLES
const sosBtn = {
  width: 150,
  height: 150,
  borderRadius: "50%",
  background: "red",
  color: "#fff",
  fontSize: 20,
};

const alertBox = {
  background: "#330000",
  padding: 10,
  marginBottom: 10,
};

const grid = {
  display: "grid",
  gap: 10,
  marginBottom: 10,
};

const riderCard = {
  display: "flex",
  justifyContent: "space-between",
  padding: 10,
  border: "1px solid #333",
  marginBottom: 5,
};

const comingBtn = {
  background: "green",
  color: "#fff",
};

const resolveBtn = {
  background: "green",
  padding: 10,
  marginRight: 10,
};

const callBtn = {
  background: "orange",
  padding: 10,
};